/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.DocTypeChooser";
        const ID_ATTRIBUTE = "data-id";
        class DocTypeChooserWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("DocTypeChooserWidgetTypeClass.createInstance()");
                    return new DocTypeChooserWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DocTypeChooserWidgetTypeClass._storeHtml()");
                    DocTypeChooserWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocTypeChooserWidgetTypeClass::constructor");
                if (DocTypeChooserWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/DocTypeChooser/doc-type-chooser.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.DocTypeChooserWidgetTypeClass = DocTypeChooserWidgetTypeClass;
        class DocTypeChooserWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                // Configuration
                this._uploadMode = false;
                this._implicitSelect = true;
                this._publishOnRequest = false;
                this._registerDeselection = true;
                // User Interface
                this._loader = null;
                this._buttonList = null;
                this._selectButton = null;
                this._currentDocType = -1;
                this.presentInstance = () => {
                    this._log.info("DocTypeChooserWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = DocTypeChooserWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('#docTypeChooserLoading');
                    this._componentDTSContainer = this._container.querySelector('#dtcDocTypesContainer');
                    this._buttonList = this._container.querySelector('#dtcButtons');
                    this._selectButton = this._buttonList.querySelector('#dtcSelectButton');
                    //this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#docTypeChooserWidgetTitle'), 'STR_WPT_DOCTYPE');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._loader, 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._selectButton.querySelector('#dtcSelectButtonLabel'), 'STR_WPT_LABEL_SELECT');
                    this._selectButton.addEventListener('click', this._selectButtonClicked);
                    // Set up config
                    let config = this._config;
                    if (config.hasOwnProperty('ImplicitSelect') && (config.ImplicitSelect != null))
                        this._implicitSelect = config.ImplicitSelect;
                    if (config.hasOwnProperty('PublishOnRequest') && (config.PublishOnRequest != null))
                        this._publishOnRequest = config.PublishOnRequest;
                    if (config.hasOwnProperty('UploadMode') && (config.UploadMode != null))
                        this._uploadMode = config.UploadMode;
                    if (config.hasOwnProperty('RegisterDeselection') && (config.RegisterDeselection != null))
                        this._registerDeselection = config.RegisterDeselection;
                    if (this._implicitSelect)
                        this._core.Functions.hideElement(this._buttonList);
                    else
                        this._core.Functions.showElement(this._buttonList);
                    this._componentDTS = new Widgets.ComponentDocTypeSelector(this._core, this._componentDTSContainer, this, this._uploadMode, false);
                    this._componentDTS.SelectionCallback = this._docTypeSelected;
                    this._componentDTS.present();
                    this._type.instanceReady(this.getHandle());
                };
                this._docTypeSelected = (ids) => {
                    this._log.info("DocTypeChooserWidgetInstanceClass._docTypeSelected()");
                    if (ids.length == 0) {
                        this._currentDocType = -1;
                        if (this._implicitSelect && this._registerDeselection)
                            this._sendDeactivation();
                    }
                    else {
                        this._currentDocType = Number(ids[0]);
                        if (this._implicitSelect)
                            this._sendActivation();
                    }
                };
                this._selectButtonClicked = (event) => {
                    this._log.info("DocTypeChooserWidgetInstanceClass._selectButtonClicked()");
                    this._sendActivation();
                };
                this._sendActivation = () => {
                    this._log.info("DocTypeChooserWidgetInstanceClass._sendActivation()");
                    let navEvent = null;
                    if (this._uploadMode) {
                        navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_SELECTED_UPLOAD);
                        navEvent.ActivationID = this._currentDocType;
                        navEvent.PrimaryContext = this._core.OBHelper.DocumentTypesById[this._currentDocType];
                    }
                    else {
                        navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPES_SELECTED_SEARCH);
                        navEvent.ActivationID = 1;
                        navEvent.PrimaryContext = [this._core.OBHelper.DocumentTypesById[this._currentDocType]];
                    }
                    // We don't currently activate new layouts, just keep things where we are
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`activating on ${this._currentDocType}`);
                    }
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._sendDeactivation = () => {
                    this._log.info("DocTypeChooserWidgetInstanceClass._sendDeactivation()");
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_DESELECTED);
                    navEvent.ActivationID = 0;
                    // We don't currently activate new layouts, just keep things where we are
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocTypeChooserWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("DocTypeChooserWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE:
                        let capabilityEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_CAPABILITY_PUBLISHED);
                        capabilityEvent.ActivationID = 0;
                        capabilityEvent.PrimaryContext = ["DocTypeChooser"];
                        capabilityEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(capabilityEvent);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_DOC_UPLOAD_INFO:
                        if (this._publishOnRequest && this._uploadMode) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_UPLOAD_DOCTYPE);
                            navEvent.ActivationID = this._currentDocType;
                            navEvent.PrimaryContext = this._core.OBHelper.DocumentTypesById[this._currentDocType];
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                        break;
                }
            }
        }
        DocTypeChooserWidgetInstanceClass.HtmlData = null;
        Widgets.DocTypeChooserWidgetInstanceClass = DocTypeChooserWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
